import React, { Component } from 'react'
import { toastContainer } from '../../../utils/toast'
import { isMobile } from '../../../utils/deviceInfo'
// import { FaExternalLinkAlt } from "react-icons/fa";
import { LuExternalLink } from 'react-icons/lu'

import {
  Alert,
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
} from 'reactstrap'
import { connect } from 'react-redux'
import moment from 'moment'

import axios from '../../../axios'
import * as url from '../../../utils/url'
import * as actionCreators from '../../../modules/actions/index'
import Loading from '../../../hoc/Loading/Loading'

import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
  LayoutHeadingShadowLeft,
  LayoutDataLines,
  LayoutRowLines,
} from '../../../components/TableComponents/RowCardShadow/RowCardShadow'

import { getTriviaFileName, minPlanLimitCheck, SURVEY_LIST } from '../data'
import ReactTooltip from 'react-tooltip'
import {
  BiDotsHorizontal,
  BiDownArrowAlt,
  BiEditAlt,
  BiEdit,
  BiLockAlt,
  BiParagraph,
  BiTrashAlt,
  BiUpArrowAlt,
  BiX,
} from 'react-icons/bi'
import {
  BsEye,
  BsThreeDots,
  BsThreeDotsVertical,
  BsUpload,
} from 'react-icons/bs'
import DeleteTriviaPopup from '../Components/DeleteTriviaPopup'
import { orderBy } from 'lodash'
import { cleanSummaryText } from '../../../utils/stringUtils'
import EmptyTable from '../../../components/EmptyTable/EmptyTable'

import CreateTriviaPopup from '../Components/CreateTrivia/CreateTriviaPopup'
import UploadLibraryModal from '../Components/UploadLibraryModal'
import UpdateLibraryModal from '../Components/UpdateLibraryModal'
import TrivvyImmediateRewardToast from '../../../components/TrivvyToast/TrivvyImmediateRewardToast'
import { FaRecycle } from 'react-icons/fa6'
import ViewSummaryCommon from '../../../components/Trivvy/ViewSummarycomon'
import WarningModal from '../../../components/Trivvy/WarningModal'
import CheckBox from 'rc-checkbox'
import LibrarySearchComponent from './Components/LibrarySearchComponent'
import BottomScrollListener from 'react-bottom-scroll-listener'

class TriviaLibrary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      createPopupOpen: false,
      preSelectedPopupData: null,
      loading: false,
      uploadModalOpen: false,
      optionsPopoverOpen: null,
      deleteConfirmModal: { open: false, data: null },
      updateLibraryModal: { open: false, data: null },
      libraryList: [],
      showMoreInfotext: false,
      customModalText: '',
      trivvyCreateMainPopupOpen: false,
      viewSummaryPopupText: null,
      selectedLibrarys: [],
      selectedLibrarysWarningModal: {
        open: false,
        message: '',
        type: '',
      },
      // Add state for rename modal
      renameModal: { open: false, data: null, newName: '' },
      // Add search state
      searchQuery: '',
      // API search results
      searchResults: null,
      isSearchActive: false,
      // Pagination for search
      searchCurrentPage: 1,
      searchHasMore: true,
      searchLoading: false,
    }
  }

  componentDidMount() {
    axios
      .get(url.getTriviaLibrary)
      .then(({ data }) => {
        this.setState({ libraryList: data.data })
      })
      .catch((err) => { })
  }

  refreshLibsList = () => {
    axios
      .get(url.getTriviaLibrary)
      .then(({ data }) => {
        this.setState({ libraryList: data.data })
      })
      .catch((err) => { })
  }

  toggleUploadModal = () => {
    if (this.state.uploadModalOpen) {
      this.setState({ uploadModalOpen: false })
    } else {
      this.setState({ uploadModalOpen: true })
    }
  }

  closeDeleteConfirmModal = () => {
    this.setState({
      deleteConfirmModal: {
        open: false,
        data: null,
      },
    })
  }

  closeUpdateLibraryModal = () => {
    this.setState({
      updateLibraryModal: {
        open: false,
        data: null,
      },
    })
  }

  // Add rename modal methods
  closeRenameModal = () => {
    this.setState({
      renameModal: {
        open: false,
        data: null,
        newName: '',
      },
    })
  }


  onViewClick = async (e, id, model, { inline = true } = {}) => {
    e.preventDefault();

    try {
      const { data } = await axios.get(url.getSignedUrl, {
        params: { id, model, inline: inline ? 1 : 0 },
      });

      const signedUrl = data.url;
      if (!signedUrl) throw new Error('No signed URL returned');

      window.open(signedUrl, '_blank', 'noopener,noreferrer');
      // const { data } = await axios.get(url.getSignedUrl, {
      //   params: { id, model, inline: inline ? 1 : 0 },
      // });

      // console.log('115 --- ', data)
      // const signedUrl = data.url;
      // if (!signedUrl) throw new Error('No signed URL returned');

      // // Open in a NEW tab and trigger download (filename comes from S3 Content-Disposition)
      // const a = document.createElement('a');
      // a.href = signedUrl;
      // a.target = '_blank';
      // a.rel = 'noopener noreferrer';
      // a.download = ''; // hint download; server header decides filename
      // document.body.appendChild(a);
      // a.click();
      // a.remove();
    } catch (err) {
      console.error('Failed to get signed URL', err);
    }
  };


  handleRenameLibrary = () => {
    const { renameModal } = this.state;
    const { data, newName } = renameModal;

    if (!newName.trim()) {
      toastContainer('Please enter a valid name', 'error');
      return;
    }

    axios
      .put(url.renameTriviaResource(data._id), {
        name: newName.trim(),
      })
      .then(({ data: response }) => {
        toastContainer('Renamed successfully', 'success');

        // Update the library list with new name
        const updatedItem = { ...data, name: newName.trim() };
        this.handleUpdateRow(updatedItem);

        // Close the modal
        this.closeRenameModal();
      })
      .catch((err) => {
        toastContainer('Error while renaming', 'error');
        console.error('Rename error:', err);
      });
  }

  onGenerateSuccess = (id) => {
    this.setState({
      createPopupOpen: false,
      preSelectedPopupData: null,
    })

    toastContainer(
      <TrivvyImmediateRewardToast
        noPlanCustomMessage={
          'Trivvy along with questions generated successfully'
        }
        trivvyIds={[id]}
        history={this.props.history}
      />,
      'success'
    )

    this.props.history.push('list')
  }

  closeGeneratePopup = () => {
    this.setState({
      createPopupOpen: false,
      preSelectedPopupData: null,
    })
  }

  openGeneratePopup = (item) => {
    this.setState({
      createPopupOpen: true,
      preSelectedPopupData: {
        name: item.name,
        s3Url: item.s3Url,
        id: item._id,
        toolId: item.toolId,
        webUrl: item.webUrl,
        libText: item.text,
      },
    })
  }

  handleUploadSuccess = (doc) => {
    console.log('dddddd--------------', doc)
    const data = [...this.state.libraryList]
    data.unshift(doc)
    this.setState({ libraryList: [...data] })
  }
  handleResourceDocUploadSuccess = (doc) => {
    console.log('dddddd--------------', doc)
    const data = [...this.state.libraryList]
    data.unshift(doc)
    this.setState({ libraryList: [...data] })
  }

  generateNewLibDocfromTools = (data) => {
    const payload = {
      s3Url: data.s3Url,
      s3Key: data.s3Key,
      refModel: 'OfficeToolkit',
      refId: data.toolId,
      status: 'PRIVATE',
    }

    const triviaForm = new FormData()

    triviaForm.append('payload', JSON.stringify(payload))

    axios
      .post(url.createTriviaLbraryDoc, triviaForm)
      .then((res) => {
        const data = res.data.data
        this.handleResourceDocUploadSuccess(data)
      })
      .catch((err) => console.log(err))
  }

  deleteResourceApiCall = (id) => {
    axios
      .delete(url.deleteTriviaResource(id))
      .then(({ data }) => {
        toastContainer('Deleted Successfully', 'success')
        let libList = [...this.state.libraryList]

        const libIndex = libList.findIndex((x) => x._id == id)

        libList.splice(libIndex, 1)

        this.setState({
          deleteConfirmModal: { open: false, data: null },
        })

        this.setState({ libraryList: libList })
      })
      .catch((err) => {
        toastContainer('Error while deleting', 'error')
      })
  }

  generateSummaryForRowItem(item) {
    const payload = {
      content:
        item.librarySourceType == 0
          ? item.webUrl
          : item.librarySourceType == 2
            ? item.text
            : item.s3Url,
      contentType:
        item.librarySourceType == 0
          ? 'LINK'
          : item.librarySourceType == 2
            ? 'TEXT'
            : 'LINK',
      _id: item._id,
      cb: this.handleUpdateRow,
    }

    this.props.setGenerateSummaryLoader({
      display: true,
      minimize: false,
      loaderApiData: payload,
    })
  }

  renderRowOptions = (item, isAdmin) => {
    const { optionsPopoverOpen } = this.state
    return (
      <div className="cursor-pointer">
        <span
          id={`surveyLibraryListRow_${item._id}`}
          onClick={(e) => {
            e.stopPropagation()
            this.setState({ optionsPopoverOpen: item._id })
          }}
          className="cursor-pointer ml-4">
          <BsThreeDots />
        </span>

        <Popover
          isOpen={optionsPopoverOpen == item._id}
          target={`surveyLibraryListRow_${item._id}`}
          toggle={() => this.setState({ optionsPopoverOpen: null })}
          placement="auto"
          hideArrow
          className="surveyListRow_Popover">
          <PopoverBody className="">
            <a
              className="dropdown-item my-1 cursor-pointer"
              onClick={(e) => {
                if (item.librarySourceType == 0 && item.webUrl) {
                  window.open(item.webUrl, 'new')
                } else if (item.librarySourceType == 2 && item.text) {
                  this.setState({
                    customModalText: item.text,
                  })
                } else {
                  // window.open(item.s3Url, 'new')
                  this.onViewClick(e, item._id, 'TriviaResource')
                }
              }}
              target="_blank">
              <LuExternalLink className="mr-3" />
              View
            </a>
            {/* <div
              className="dropdown-item my-1 cursor-pointer">
          <a className="dropdown-item my-1 cursor-pointer" href={item.s3Url} target="_blank">
          View
          </a>
          </div> */}

            {/* Admin-only options */}
            {isAdmin && (
              <>
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    this.setState({
                      optionsPopoverOpen: null,
                      updateLibraryModal: {
                        open: true,
                        data: item,
                      },
                    })
                  }}>
                  <BiEditAlt className="mr-3" /> Update (Change Privacy,File)
                </div>

                {/* Adding rename option */}
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    this.setState({
                      optionsPopoverOpen: null,
                      renameModal: {
                        open: true,
                        data: item,
                        newName: item.name || '',
                      },
                    })
                  }}>
                  <BiEdit className="mr-3" /> Rename
                </div>

                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    this.setState({
                      optionsPopoverOpen: null,
                      deleteConfirmModal: {
                        open: true,
                        data: item,
                      },
                    })
                  }}>
                  <BiTrashAlt className="mr-3" /> Delete
                </div>
              </>
            )}

            {/* View summary - available to all */}
            {item.summaryText ? (
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.setState({
                    viewSummaryPopupText: item.summaryText,
                    optionsPopoverOpen: null,
                  })
                }}>
                <BsEye className="mr-3" /> View summary
              </div>
            ) : (
              // Generate summary - admin only
              isAdmin && (
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    this.generateSummaryForRowItem(item)
                    this.setState({
                      optionsPopoverOpen: null,
                    })
                  }}>
                  <FaRecycle className="mr-3" /> Generate summary
                </div>
              )
            )}
          </PopoverBody>
        </Popover>
      </div>
    )
  }

  handleLibrary = (item, e) => {
    if (item.librarySourceType == 0 && item.webUrl) {
      window.open(item.webUrl, "new");
    } else if (item.librarySourceType == 2 && item.text) {
      this.setState({ customModalText: item.text });
    } else {
      // Use the signed URL for S3 files instead of direct s3Url
      this.onViewClick(e, item._id, 'TriviaResource');
    }
  }

  handleUpdateRow = (data) => {
    const index = [...this.state.libraryList].findIndex(
      (x) => x._id == data._id
    )

    if (index >= 0) {
      const libList = [...this.state.libraryList]
      libList[index] = { ...libList[index], ...data }
      this.setState({ libraryList: libList, uploadModalOpen: false })
    }
  }
  incrementTrivCount = (libId) => {
    const index = [...this.state.libraryList].findIndex((x) => x._id == libId)

    if (index >= 0) {
      const libList = [...this.state.libraryList]
      libList[index].triviaCount = libList[index].triviaCount + 1
      this.setState({ libraryList: libList })
    }
  }

  sortComponent = (key) => {
    const { sortParams } = this.props
    // console.log('key --- ', key)
    if (JSON.stringify(sortParams.sortBy) === JSON.stringify(key)) {
      if (sortParams.sortOrder === 'desc') {
        return (
          <BiDownArrowAlt
            size={'13px'}
            onClick={() => this.changeSortField(key, 'asc')}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        )
      } else {
        return (
          <BiUpArrowAlt
            size={'13px'}
            onClick={() => this.changeSortField(key, 'desc')}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        )
      }
    } else {
      return (
        <BiUpArrowAlt
          size={'13px'}
          onClick={() => this.changeSortField(key, 'desc')}
          className="cursor-pointer trivia-list-sort-arrow-pos"
        />
      )
    }
  }

  changeSortField = (key, order) => {
    this.props.updateSortParams({
      sortBy: key,
      sortOrder: order,
    })
  }

  getTotalResponsesOfLibrary = (responsesArray) => {
    let totalCount = 0
    for (const item of responsesArray) {
      totalCount += item.responses
    }
    return totalCount
  }

  handleSortChange = (key, order) => {
    let libs = [...this.state.libraryList]

    switch (key) {
      case 'fileName':
        libs = orderBy(
          libs,
          (itm) => {
            const str = getTriviaFileName({
              uploadUrl: itm.s3Url,
              uploadFileName: itm.s3Key,
              librarySourceType: itm.librarySourceType,
              libName: itm.name,
              webUrl: itm.webUrl,
            })

            return str.toLowerCase()
          },
          [order]
        )
        break
      case 'uploadDate':
        libs = orderBy(libs, (itm) => itm.uploadDate, [order])
        break
      case 'status':
        libs = orderBy(libs, (itm) => (itm.status || '').toLowerCase(), [order])
        break
      case 'triviaCount':
        libs = orderBy(libs, (itm) => itm.triviaCount, [order])
        break
      case 'responsesCount':
        libs = orderBy(
          libs,
          (itm) => this.getTotalResponsesOfLibrary(itm.responsesCounts || []),
          [order]
        )
        break

      default:
        libs = orderBy(libs, (itm) => itm[key], [order])
        break
    }
    this.setState({ libraryList: libs })
  }

  handleLibraryRowCheckboxClick = (value, id) => {
    const librarys = [...this.state.selectedLibrarys]

    if (librarys.includes(id)) {
      const newLibs = librarys.filter((x) => x != id)
      this.setState({ selectedLibrarys: newLibs })
    } else {
      librarys.push(id)
      this.setState({ selectedLibrarys: librarys })
    }
  }

  handleMultipleDelete = () => {
    axios
      .post(url.deleteMultipleLibrarys, {
        librarysToDelete: this.state.selectedLibrarys,
      })
      .then((data) => {
        const deletedIds = this.state.selectedLibrarys

        const filtered = [...this.state.libraryList].filter(
          (x) => !deletedIds.includes(x._id)
        )

        this.setState({
          libraryList: [...filtered],
        })

        toastContainer('Deleted succesfully', 'success')

        this.setState({ selectedLibrarys: [] })
      })
      .catch((err) => {
        console.log(err)
        toastContainer('Error occured while deleting trivvys', 'error')
      })
  }

  // Handle search with pagination
  handleSearch = (query) => {
    // Reset search state for new search
    this.setState(
      {
        searchQuery: query,
        searchResults: [],
        isSearchActive: true,
        searchCurrentPage: 1,
        searchHasMore: true,
      },
      () => {
        this.performSearchWithPagination(query, 1);
      }
    );
  };

  // Perform search API call with pagination
  performSearchWithPagination = (query, page) => {
    this.setState({ searchLoading: true });

    const params = {
      search: query,
      source: 'library',
      page: page,
      limit: 10,
    };

    axios
      .get(url.trivvyKeywordSearch, { params })
      .then(({ data }) => {
        const libraryResults =
          data.data && data.data.librarys ? data.data.librarys : [];

        this.setState((prevState) => ({
          searchResults:
            page === 1
              ? libraryResults
              : [...prevState.searchResults, ...libraryResults],
          searchLoading: false,
          searchHasMore: libraryResults.length === 10, // If we got 10 items, there might be more
        }));
      })
      .catch((err) => {
        console.error('Error fetching search results:', err);
        this.setState({
          searchLoading: false,
          searchHasMore: false,
        });
      });
  };

  // Handle scroll to load more search results
  handleSearchScrollBottom = () => {
    const { searchHasMore, searchLoading, searchCurrentPage, searchQuery, isSearchActive } = this.state;

    if (isSearchActive && searchHasMore && !searchLoading) {
      const nextPage = searchCurrentPage + 1;
      this.setState({ searchCurrentPage: nextPage }, () => {
        this.performSearchWithPagination(searchQuery, nextPage);
      });
    }
  };

  // Handle search results from API (keeping for backward compatibility)
  handleSearchResults = (results, query) => {
    this.setState({
      searchResults: results,
      searchQuery: query,
      isSearchActive: true,
    })
  }

  // Clear search and show all libraries
  handleClearSearch = () => {
    this.setState({
      searchResults: null,
      searchQuery: '',
      isSearchActive: false,
      searchCurrentPage: 1,
      searchHasMore: true,
      searchLoading: false,
    })
  }

  // Filter library list based on search query or API results
  getFilteredLibraryList = () => {
    const { libraryList, searchResults, isSearchActive } = this.state

    // If API search is active, return API results
    if (isSearchActive && searchResults !== null) {
      return searchResults
    }

    // Otherwise return full list
    return libraryList
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.sortParams) !==
      JSON.stringify(nextProps.sortParams)
    ) {
      this.handleSortChange(
        nextProps.sortParams.sortBy,
        nextProps.sortParams.sortOrder
      )
    }
  }
  render() {
    const orgObject = this.props.user.profile.organizationId
    const trivvy_plan_type = orgObject && orgObject.trivvyPlanType
    const isAdmin =
      this.props.user.profile.orgAdmin ||
      this.props.user.profile.role == "Admin"
    const tableCols = {
      name: 5,
      action: 2,
      uploadDate: 2,
      privacy: 2,
      // triviaCount: 2,
      // responsesCounts: 1,
    }

    const tableColsMobile = {
      uploadDate: 4,
      // triviaCount: 2,
      action: 3,
      // responsesCounts: 3,
    }

    const {
      createPopupOpen,
      preSelectedPopupData,
      loading,
      uploadModalOpen,
      deleteConfirmModal,
      updateLibraryModal,
      libraryList,
      showMoreInfotext,
      customModalText,
      trivvyCreateMainPopupOpen,
      viewSummaryPopupText,
      selectedLibrarys,
      selectedLibrarysWarningModal,
      // Add rename modal to destructuring
      renameModal,
    } = this.state

    return (
      <div className="library_page">
        {selectedLibrarysWarningModal && selectedLibrarysWarningModal.open ? (
          <WarningModal
            open={selectedLibrarysWarningModal.open}
            message={selectedLibrarysWarningModal.message}
            type={selectedLibrarysWarningModal.type}
            onCancel={() => {
              this.setState({
                selectedLibrarysWarningModal: {
                  open: false,
                  message: '',
                  type: '',
                },
              })
            }}
            onOk={() => {
              this.handleMultipleDelete()

              this.setState({
                selectedLibrarysWarningModal: {
                  open: false,
                  message: '',
                  type: '',
                },
              })
            }}
            onClose={() => {
              this.setState({
                selectedLibrarysWarningModal: {
                  open: false,
                  message: '',
                  type: '',
                },
              })
            }}
          />
        ) : (
          ''
        )}
        {customModalText && (
          <Modal isOpen={true} className={isMobile ? 'm-0' : ''}>
            <ModalHeader
              toggle={() => {
                this.setState({ customModalText: false })
              }}
            >
              <div>
                <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '4px' }}>
                  Text Content
                </div>
              </div>
            </ModalHeader>
            <ModalBody className="p-3">
              <div style={{ fontSize: '14px', color: '#374151', whiteSpace: 'pre-wrap' }}>
                {customModalText}
              </div>
            </ModalBody>
            <ModalFooter style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
              <Button
                onClick={() => this.setState({ customModalText: false })}
                style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  backgroundColor: '#f3f4f6',
                  border: 'none',
                  color: '#374151',
                }}
              >
                Close
              </Button>
            </ModalFooter>
          </Modal>
        )}
        {createPopupOpen && preSelectedPopupData ? (
          <CreateTriviaPopup
            open={createPopupOpen}
            onClose={this.closeGeneratePopup}
            onAddSuccess={this.onGenerateSuccess}
            preSelectedData={preSelectedPopupData}
            generateFromLibrary={true}
            resourceId={preSelectedPopupData.id}
            incrementTrivCount={this.incrementTrivCount}
            generateNewLibDocfromTools={this.generateNewLibDocfromTools}
            user={this.props.user}
          />
        ) : (
          ''
        )}

        {viewSummaryPopupText ? (
          <Modal isOpen={true} className={isMobile ? 'm-0' : ''}>
            <ModalHeader
              toggle={() => this.setState({ viewSummaryPopupText: null })}
            >
              <div>
                <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '4px' }}>
                  Summary
                </div>
              </div>
            </ModalHeader>
            <ModalBody className="p-3">
              <div style={{ fontSize: '14px', color: '#374151', whiteSpace: 'pre-wrap' }}>
                {cleanSummaryText(viewSummaryPopupText)}
              </div>
            </ModalBody>
            <ModalFooter style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
              <Button
                onClick={() => this.setState({ viewSummaryPopupText: null })}
                style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  backgroundColor: '#f3f4f6',
                  border: 'none',
                  color: '#374151',
                }}
              >
                Close
              </Button>
            </ModalFooter>
          </Modal>
        ) : (
          ''
        )}
        {trivvyCreateMainPopupOpen ? (
          <CreateTriviaPopup
            open={trivvyCreateMainPopupOpen}
            onClose={() => {
              this.setState({
                trivvyCreateMainPopupOpen: false,
                preSelectedLibraryForPopup: null,
              })
            }}
            onAddSuccess={this.onGenerateSuccess}
            incrementTrivCount={this.incrementTrivCount}
            user={this.props.user}
            autoSelectedTrivvyType="AI"
            fromRewards
            refreshLibsList={this.refreshLibsList}
            preSelectedLibraryItem={this.state.preSelectedLibraryForPopup}
          />
        ) : (
          ''
        )}
        {updateLibraryModal &&
          updateLibraryModal.open &&
          updateLibraryModal.data ? (
          <UpdateLibraryModal
            open={updateLibraryModal.open}
            onClose={this.closeUpdateLibraryModal}
            libraryData={updateLibraryModal.data}
            onUpdateSuccess={(data) => {
              this.handleUpdateRow(data)
            }}
            user={this.props.user}
          />
        ) : (
          ''
        )}

        {/* Add rename modal */}
        {renameModal && renameModal.open && renameModal.data ? (
          <Modal isOpen={renameModal.open} className={isMobile ? 'm-0' : ''}>
            <ModalHeader
              toggle={this.closeRenameModal}
            >
              <div>
                <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '4px' }}>
                  Rename Library Item
                </div>
              </div>
            </ModalHeader>
            <ModalBody className="p-3">
              <Label style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>New Name:</Label>
              <Input
                type="text"
                value={renameModal.newName}
                onChange={(e) =>
                  this.setState({
                    renameModal: {
                      ...renameModal,
                      newName: e.target.value,
                    },
                  })
                }
                placeholder="Enter new name"
                style={{
                  fontSize: '14px',
                  padding: '10px 12px',
                  borderRadius: '6px',
                  border: '1px solid #d1d5db',
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    this.handleRenameLibrary();
                  }
                }}
              />
            </ModalBody>
            <ModalFooter style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
              <Button
                color="link"
                onClick={this.closeRenameModal}
                style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  border: 'none',
                  backgroundColor: 'transparent',
                  color: '#6b7280',
                  textDecoration: 'none',
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={this.handleRenameLibrary}
                disabled={!renameModal.newName.trim()}
                style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  backgroundColor: '#1062fe',
                  border: 'none',
                  color: '#ffffff',
                }}
              >
                Rename
              </Button>
            </ModalFooter>
          </Modal>
        ) : (
          ''
        )}

        {uploadModalOpen && (
          <UploadLibraryModal
            open={uploadModalOpen}
            onClose={this.toggleUploadModal}
            onUploadSuccess={this.handleUploadSuccess}
            user={this.props.user}
          />
        )}

        {deleteConfirmModal.open && deleteConfirmModal.data && (
          <DeleteTriviaPopup
            isLibrary
            open={deleteConfirmModal.open}
            onClose={this.closeDeleteConfirmModal}
            item={{
              name: getTriviaFileName({
                uploadUrl: deleteConfirmModal.data.s3Url,
                librarySourceType: deleteConfirmModal.data.librarySourceType,
                libName: deleteConfirmModal.data.name,
                webUrl: deleteConfirmModal.data.webUrl,
              }),
            }}
            onDeleteItem={() =>
              this.deleteResourceApiCall(deleteConfirmModal.data._id)
            }
          />
        )}

        {minPlanLimitCheck(trivvy_plan_type, '003') ? (
          <div className='alert-section'>
            <Alert
              color="primary"
              className="col-lg-10 col-md-10 ml-lg-4 mx-sm-2">




              {isMobile ? (
                <div>
                  <span className="alert-primary-text">
                    <span className="alert-primary-icon"></span>
                    <span>
                      Library is a collection of resources uploaded by the
                      {showMoreInfotext
                        ? ` Admin(s)
                      for this account. Click on any item below to view the document or a summary.`
                        : ''}
                      {showMoreInfotext ? (
                        <div
                          onClick={() =>
                            this.setState({ showMoreInfotext: false })
                          }
                          className="cursor-pointer font-weight-bold">
                          Show less -
                        </div>
                      ) : (
                        <div
                          onClick={() =>
                            this.setState({ showMoreInfotext: true })
                          }
                          className="cursor-pointer font-weight-bold">
                          Show more +
                        </div>
                      )}
                    </span>
                  </span>
                </div>
              ) : (
                <span className="alert-primary-text">
                  <span className="alert-primary-icon"></span>
                  <span>
                    The Library is a collection of resources uploaded by the Admin(s) for this account. Click on any item below to view the document or a summary.
                  </span>
                </span>
              )}
            </Alert>
          </div>
        ) : null}

        {isAdmin && (
          <div className="d-flex upload-document-btn">
            <Button
              onClick={() => {
                var selected = this.state.selectedLibrarys;
                var preSelectedLib = null;
                if (selected && selected.length === 1) {
                  var selectedId = selected[0];
                  preSelectedLib = this.state.libraryList.find(function(lib) { return lib._id === selectedId; });
                }
                this.setState({
                  trivvyCreateMainPopupOpen: true,
                  preSelectedLibraryForPopup: preSelectedLib || null,
                })
              }}
              className="trivia-action-button-main ml-4 create-trivvy-btn-itm">
              + Create Trivvy
            </Button>

            <Button
              onClick={this.toggleUploadModal}
              className="trivia-action-button-main ml-4 trivia-action-primary-btn">
              <BsUpload className="mr-1" size={12} /> Upload document
            </Button>
          </div>
        )}

        {isAdmin && selectedLibrarys && selectedLibrarys.length ? (
          <div style={{}} className="mt-4">
            <b
              className="mx-2 text-danger cursor-pointer underline_txt mr-2"
              onClick={() => {
                this.setState({
                  selectedLibrarysWarningModal: {
                    open: true,
                    message:
                      'Are you sure you want to delete selected librarys',
                    type: 'DELETE',
                  },
                })
              }}>
              Delete
            </b>

            <span>Selected librarys ({selectedLibrarys.length})</span>
          </div>
        ) : (
          ''
        )}

        <div>
          {libraryList.length == -1 ? (
            <div className="d-flex justify-content-center">
              {loading ? (
                <div></div>
              ) : (
                <EmptyTable
                  title={'No libraries found'}
                  subtitle={
                    'You havent uploaded any libraries yet. Please upload from button above.'
                  }
                />
              )}
            </div>
          ) : (
            <div>
              {!isMobile ? (
                <div className="trivia_survey_list_table px-3 trivia_survey_library_table">
                  {/* Desktop Search Input */}
                  <div className="my-3 ml-2" style={{ maxWidth: '500px' }}>
                    <LibrarySearchComponent
                      user={this.props.user.profile}
                      onSearch={this.handleSearch}
                      onClearSearch={this.handleClearSearch}
                      isSearching={this.state.searchLoading && this.state.searchCurrentPage === 1}
                    />
                  </div>

                  <div className="my-4 trivia_survey_list_table_contents">
                    <div className={`${this.getFilteredLibraryList().length > 0 ? 'margin-library-table' : 'margin-library-table-empty'}`}>


                      <LayoutRowShadow className="row-shadow-header-no-shadow">
                        {!isMobile && (
                          <LayoutHeadingShadowLeft
                            className={'text-left'}
                            colWidth={tableCols.name}>
                            Name {this.sortComponent('fileName')}
                          </LayoutHeadingShadowLeft>
                        )}
                        <LayoutHeadingShadow
                          className={'justify-content-center '}
                          colWidth={tableCols.uploadDate}>
                          Upload Date {this.sortComponent('uploadDate')}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={'justify-content-center '}
                          colWidth={tableCols.privacy}>
                          Privacy {this.sortComponent('status')}
                        </LayoutHeadingShadow>
                        {/* <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableCols.triviaCount}>
                        Trivvy Count {this.sortComponent('triviaCount')}
                      </LayoutHeadingShadow>

                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableCols.responsesCounts}>
                        Responses {this.sortComponent('responsesCounts')}
                      </LayoutHeadingShadow> */}

                        <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.action}></LayoutHeadingShadow>
                      </LayoutRowShadow>

                      <BottomScrollListener
                        onBottom={this.state.isSearchActive ? this.handleSearchScrollBottom : () => { }}
                        debounce={200}
                      >
                        {(scrollRef) => (
                          <div
                            ref={scrollRef}
                            className={`trivia_survey_list_table_contents_scroll ${this.getFilteredLibraryList().length == 0 ? 'trivvy-no-results' : ''
                              }`}>
                            {!isMobile && this.getFilteredLibraryList().length > 0 ? (
                              this.getFilteredLibraryList().map((item, idx) => {
                                return (
                                  <LayoutRowShadow key={idx}>
                                    <LayoutData
                                      colWidth={tableCols.name}
                                      className="cursor-pointer">
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="survey-item-title h50-minCenter"
                                          data-tip={getTriviaFileName({
                                            uploadUrl: item.s3Url,
                                            uploadFileName: item.s3Key,
                                            librarySourceType: item.librarySourceType,
                                            libName: item.name,
                                            webUrl: item.webUrl,
                                          })}>
                                          {isAdmin && (
                                            <CheckBox
                                              checked={selectedLibrarys.includes(
                                                item._id
                                              )}
                                              className="mr-2"
                                              onChange={(e) => {
                                                this.handleLibraryRowCheckboxClick(
                                                  e.target.checked,
                                                  item._id
                                                )
                                              }}
                                            />
                                          )}
                                          <span
                                            className="cursor-pointer"
                                            onClick={(e) => {
                                              // Comment out the old navigation logic
                                              // if (
                                              //   minPlanLimitCheck(
                                              //     trivvy_plan_type,
                                              //     '003'
                                              //   )
                                              // ) {
                                              //   this.props.history.push(
                                              //     `/home/trivia/${this.props.user.profile.organizationId._id}/library-item/${item._id}/view/questions`
                                              //   )
                                              // } else {
                                              //   if (
                                              //     item.librarySourceType == 0 &&
                                              //     item.webUrl
                                              //   ) {
                                              //     window.open(item.webUrl, 'new')
                                              //   } else if (
                                              //     item.librarySourceType == 2 &&
                                              //     item.text
                                              //   ) {
                                              //     this.setState({
                                              //       customModalText: item.text,
                                              //     })
                                              //   } else {
                                              //     window.open(item.s3Url, 'new')
                                              //   }
                                              // }

                                              // Use handleLibrary function instead
                                              this.handleLibrary(item, e)
                                            }}>
                                            {getTriviaFileName({
                                              uploadUrl: item.s3Url,
                                              uploadFileName: item.s3Key,
                                              librarySourceType:
                                                item.librarySourceType,
                                              libName: item.name,
                                              webUrl: item.webUrl,
                                            })}
                                          </span>
                                        </div>
                                        <span
                                          className={`text-info ${isMobile ? '' : 'ml-1'
                                            }`}
                                          style={{ whiteSpace: 'nowrap' }}>
                                          {item.summaryText ? (
                                            <span
                                              className="my-1 cursor-pointer"
                                              onClick={(e) => {
                                                e.stopPropagation()
                                                this.setState({
                                                  viewSummaryPopupText:
                                                    item.summaryText,
                                                  optionsPopoverOpen: null,
                                                })
                                              }}>
                                              (View summary)
                                            </span>
                                          ) : (
                                            isAdmin ? (
                                              <span
                                                className="my-1 cursor-pointer"
                                                onClick={(e) => {
                                                  e.stopPropagation()
                                                  this.generateSummaryForRowItem(item)
                                                  this.setState({
                                                    optionsPopoverOpen: null,
                                                  })
                                                }}>
                                                (Generate summary)
                                              </span>
                                            ) : null
                                          )}
                                        </span>
                                        <ReactTooltip />
                                      </div>
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center word-break-lib"
                                      colWidth={tableCols.uploadDate}>
                                      {moment(item.uploadDate).format(
                                        'h:mma on MMM D, YYYY'
                                      )}
                                    </LayoutData>
                                    <LayoutData
                                      className="text-center word-break-lib"
                                      colWidth={tableCols.privacy}>
                                      {item.status === 'ENTERPRISE' ? 'Enterprise'
                                        : item.status === 'ADMIN' ? 'Only Admins'
                                        : item.status === 'PRIVATE' ? 'Private'
                                        : item.status === 'CUSTOM' ? 'Custom'
                                        : item.status || '-'}
                                    </LayoutData>
                                    {/* <LayoutData
                                className="text-center"
                                colWidth={tableCols.triviaCount}>
                                {item.triviaCount >= 0 ? item.triviaCount : 0}
                              </LayoutData>
                              <LayoutData
                                className="text-center"
                                colWidth={tableCols.responsesCounts}>
                                {this.getTotalResponsesOfLibrary(
                                  item.responsesCounts || []
                                )}
                              </LayoutData> */}

                              <LayoutData
                                className="text-center"
                                colWidth={tableCols.action}>
                                <div
                                  className="mx-3"
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}>
                                  {isAdmin && !minPlanLimitCheck(
                                    trivvy_plan_type,
                                    '003'
                                  ) ? (
                                    <Button
                                      className="trivia-action-button-main"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        this.openGeneratePopup(item)
                                      }}
                                      style={{
                                        whiteSpace: 'nowrap',
                                      }}
                                      size="sm">
                                      + Generate Trivvy
                                    </Button>
                                  ) : (
                                    <div></div>
                                  )}

                                        {item._id ? (
                                          this.renderRowOptions(item, isAdmin)
                                        ) : (
                                          <span
                                            className="ml-4"
                                            style={{ width: '18px' }}></span>
                                        )}
                                      </div>
                                    </LayoutData>
                                  </LayoutRowShadow>
                                )
                              })
                            ) : (
                              <span>
                                {this.state.searchLoading && this.state.isSearchActive && this.state.searchCurrentPage === 1
                                  ? 'Searching...'
                                  : this.state.isSearchActive
                                    ? 'No results found for your search'
                                    : 'No libraries uploaded yet'}
                              </span>
                            )}
                            {this.state.searchLoading && this.state.isSearchActive && this.state.searchCurrentPage > 1 && (
                              <div className="text-center my-3">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="sr-only">Loading...</span>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </BottomScrollListener>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="library-mobile-container" style={{ padding: '24px 16px' }}>
                  {/* Mobile Search Input */}
                  <div style={{ marginBottom: '20px' }}>
                    <LibrarySearchComponent
                      user={this.props.user.profile}
                      onSearch={this.handleSearch}
                      onClearSearch={this.handleClearSearch}
                      isSearching={this.state.searchLoading && this.state.searchCurrentPage === 1}
                    />
                  </div>

                  {/* Library Cards List */}
                  <BottomScrollListener
                    onBottom={this.state.isSearchActive ? this.handleSearchScrollBottom : () => { }}
                    debounce={200}
                  >
                    {(scrollRef) => (
                      <div ref={scrollRef} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                        {this.getFilteredLibraryList().length === 0 ? (
                          <div style={{
                            backgroundColor: '#ffffff',
                            borderRadius: '12px',
                            padding: '24px 16px',
                            textAlign: 'center',
                            color: '#6b7280',
                            fontSize: '14px',
                          }}>
                            {this.state.searchLoading && this.state.isSearchActive && this.state.searchCurrentPage === 1
                              ? 'Searching...'
                              : this.state.searchQuery.trim()
                                ? 'No results found for your search'
                                : 'No libraries uploaded yet'}
                          </div>
                        ) : (
                          this.getFilteredLibraryList().map((item, idx) => {
                            const fileName = getTriviaFileName({
                              uploadUrl: item.s3Key,
                              uploadFileName: item.s3Key,
                              librarySourceType: item.librarySourceType,
                              libName: item.name,
                              webUrl: item.webUrl,
                            })

                            const sourceLabel = ''

                            return (
                              <div
                                key={idx}
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '12px',
                                  padding: '14px 16px',
                                  position: 'relative',
                                }}
                              >
                                {/* Options button */}
                                <div style={{ position: 'absolute', top: '12px', right: '12px' }}>
                                  {item._id ? this.renderRowOptions(item, isAdmin) : null}
                                </div>

                                {/* Card content - clickable area */}
                                <div
                                  onClick={(e) => {
                                    // Comment out the old navigation logic
                                    // if (minPlanLimitCheck(trivvy_plan_type, '003')) {
                                    //   this.props.history.push(
                                    //     `/home/trivia/${this.props.user.profile.organizationId._id}/library-item/${item._id}/view/questions`
                                    //   )
                                    // } else {
                                    //   if (item.librarySourceType == 0 && item.webUrl) {
                                    //     window.open(item.webUrl, 'new')
                                    //   } else if (item.librarySourceType == 2 && item.text) {
                                    //     this.setState({ customModalText: item.text })
                                    //   } else {
                                    //     window.open(item.s3Url, 'new')
                                    //   }
                                    // }

                                    // Use handleLibrary function instead
                                    this.handleLibrary(item, e)
                                  }}
                                  className="cursor-pointer"
                                >
                                  {/* Title */}
                                  <span style={{
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#1a1a1a',
                                    margin: '0 0 4px 0',
                                    paddingRight: '28px',
                                    lineHeight: '1.4',
                                    wordBreak: 'break-word',
                                  }}>
                                    {fileName}
                                  </span>

                                  {/* Meta info row */}
                                  <p style={{
                                    fontSize: '14px',
                                    color: '#6b7280',
                                    margin: '2px 0 6px 0',
                                  }}>
                                    {sourceLabel} Updated {moment(item.uploadDate).format('MMM D, YYYY')}
                                  </p>
                                </div>

                                {/* View summary link */}
                                {item.summaryText ? (
                                  <span
                                    className="cursor-pointer"
                                    style={{
                                      fontSize: '14px',
                                      color: '#4a6fa5',
                                      fontWeight: '500',
                                      textDecoration: 'underline',
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      this.setState({
                                        viewSummaryPopupText: item.summaryText,
                                        optionsPopoverOpen: null,
                                      })
                                    }}
                                  >
                                    View summary
                                  </span>
                                ) : (
                                  isAdmin ? (
                                    <span
                                      className="cursor-pointer"
                                      style={{
                                        fontSize: '14px',
                                        color: '#4a6fa5',
                                        fontWeight: '500',
                                        textDecoration: 'underline',
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        this.generateSummaryForRowItem(item)
                                        this.setState({ optionsPopoverOpen: null })
                                      }}
                                    >
                                      Generate summary
                                    </span>
                                  ) : null
                                )}
                                <ReactTooltip />
                              </div>
                            )
                          })
                        )}
                        {this.state.searchLoading && this.state.isSearchActive && this.state.searchCurrentPage > 1 && (
                          <div style={{
                            backgroundColor: '#ffffff',
                            borderRadius: '12px',
                            padding: '16px',
                            textAlign: 'center',
                          }}>
                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </BottomScrollListener>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.triviaLibraryList
        ? state.sortFilterParams.triviaLibraryList.sort &&
          state.sortFilterParams.triviaLibraryList.sort.hasOwnProperty('sortBy')
          ? state.sortFilterParams.triviaLibraryList.sort
          : { sortBy: '', sortOrder: '' }
        : { sortBy: '', sortOrder: '' },
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    //   updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    //   orgChangeSuccess: data => dispatch(actionCreators.orgChangeSuccess(data)),
    //   setCurrentTrivia: data => dispatch(actionCreators.setCurrentTrivia(data)),
    updateSortParams: (data) =>
      dispatch(actionCreators.updateLibrarySort(data)),
    setGenerateSummaryLoader: (data) =>
      dispatch(actionCreators.setGenerateSummaryLoader(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaLibrary, axios))
